import Vue from "vue";
import VueRouter from "vue-router";

// Guards
import LoginGuard from "./login";

// import routes
import SignIn from "../components/auth/SignIn.vue";
import PatientTypeIndex from "../components/auth/PatientTypeIndex.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/welcome",
    name: "Welcome",
    component: PatientTypeIndex,
    beforeEnter: LoginGuard
  },
  {
    path: "/new-appointment",
    name: "AppointmentRequestAdd",
    component: () =>
      import("../components/appointment_requests/AppointmentRequestAdd.vue"),
    beforeEnter: LoginGuard
  },
  {
    path: "/thanks",
    name: "AppointmentRequestFinished",
    component: () =>
      import(
        "../components/appointment_requests/AppointmentRequestFinished.vue"
      ),
    props: true
  },
  {
    path: "/signin",
    name: "SignIn",
    component: SignIn,
    beforeEnter: LoginGuard
  },
  {
    path: "/confirm/:hash",
    name: "Confirm",
    component: () => import("../components/auth/SignInConfirm.vue"),
    beforeEnter: LoginGuard
  },
  {
    path: "/home",
    name: "Home",
    component: () => import("../components/home/Home.vue"),
    beforeEnter: LoginGuard
  },
  {
    path: "/documents",
    name: "Documents",
    component: () => import("../components/documents/Documents.vue"),
    beforeEnter: LoginGuard
  },
  {
    path: "/document/:sharedDocumentId",
    name: "Document",
    component: () => import("../components/documents/Document.vue"),
    beforeEnter: LoginGuard
  },
  {
    path: "/document_group/:sharedDocumentId",
    name: "DocumentGroup",
    component: () => import("../components/documents/DocumentGroup2.vue"),
    beforeEnter: LoginGuard
  },
  {
    path: "/appointments",
    name: "Appointments",
    component: () => import("../components/appointments/Appointments.vue"),
    beforeEnter: LoginGuard
  },
  {
    path: "/messages",
    name: "Messages",
    component: () => import("../components/chat/Chats.vue"),
    beforeEnter: LoginGuard
  },
  {
    path: "/profile",
    name: "Profile",
    component: () => import("../components/profile/Profile.vue"),
    beforeEnter: LoginGuard
  },
  {
    path: "/billing",
    name: "Billing",
    component: () => import("../components/billing/Billing.vue"),
    props: true,
    beforeEnter: LoginGuard,
    children: [
      {
        path: "invoice/:invoiceId",
        name: "InvoiceDetails",
        component: () => import("../components/billing/InvoiceDetails.vue"),
        props: true,
        beforeEnter: LoginGuard
      },
      {
        path: "invoice/payment/:invoiceId",
        name: "InvoicePayment",
        component: () => import("../components/billing/InvoicePayment.vue"),
        props: true,
        beforeEnter: LoginGuard
      }
    ]
  },
  {
    path: "/billing/addPaymentMethod",
    name: "AddPaymentMethod",
    component: () => import("../components/billing/Billing.vue"),
    beforeEnter: LoginGuard
  },
  {
    path: "/redirect-care-clinics",
    beforeEnter: () => location.href = "https://care-clinics.com/email-care-counseling/"
  },
  { path: "*", redirect: "/welcome" }
];

const router = new VueRouter({
  routes,
  mode: "history"
});

export default router;
